"use strict";

exports.__esModule = true;
exports.default = void 0;
var _root = _interopRequireDefault(require("./_root.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Used to detect overreaching core-js shims. */
var coreJsData = _root.default['__core-js_shared__'];
var _default = exports.default = coreJsData;